import { useEffect, useState } from "react";
import ReactDomServer from "react-dom/server";
import _ from "lodash";

import InfoWindow, { IInfoWindow } from "components/Map/InfoWindow";

const Marker = ({
  markerInfo,
  showButton = true,
  ...options
}: google.maps.marker.AdvancedMarkerElementOptions & {
  markerInfo: IInfoWindow["marker"];
  showButton?: boolean;
}) => {
  const [marker, setMarker] =
    useState<google.maps.marker.AdvancedMarkerElement>();

  useEffect(() => {
    google.maps.importLibrary("marker").then((module) => {
      const { AdvancedMarkerElement } = module as google.maps.MarkerLibrary;

      if (_.isNil(marker)) {
        setMarker(new AdvancedMarkerElement({ ...options, zIndex: 999 }));
      }
    });
  }, [marker, options]);

  useEffect(() => {
    if (!_.isNil(marker) && !_.isNil(options.position)) {
      marker.position = options.position;
    }
  }, [marker, options]);

  useEffect(() => {
    if (!_.isNil(marker)) {
      const infowindow = new google.maps.InfoWindow({
        content: ReactDomServer.renderToString(
          <InfoWindow marker={markerInfo} showButton={showButton} />
        ),
      });

      const eventListener = marker.addListener("gmp-click", () => {
        infowindow.open(options.map, marker);
      });

      return () => {
        eventListener.remove();
      };
    }
  }, [marker, options, markerInfo, showButton]);

  return null;
};

export default Marker;
